/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevDailyCountDto
 */
export interface DevDailyCountDto {
    /**
     * 
     * @type {Date}
     * @memberof DevDailyCountDto
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof DevDailyCountDto
     */
    count: number;
}

/**
 * Check if a given object implements the DevDailyCountDto interface.
 */
export function instanceOfDevDailyCountDto(value: object): value is DevDailyCountDto {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function DevDailyCountDtoFromJSON(json: any): DevDailyCountDto {
    return DevDailyCountDtoFromJSONTyped(json, false);
}

export function DevDailyCountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevDailyCountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'count': json['count'],
    };
}

export function DevDailyCountDtoToJSON(json: any): DevDailyCountDto {
    return DevDailyCountDtoToJSONTyped(json, false);
}

export function DevDailyCountDtoToJSONTyped(value?: DevDailyCountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': (formatDateOnly(value['date'])),
        'count': value['count'],
    };
}

